import React from "react"

import { Checkbox } from "@tenforce/product-fields"

import { updateField } from "../../slice"
import { useAppDispatch, useAppSelector } from "../../../../hooks"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { Labels } from "../../../../util/Translations"
import { ICheckboxField } from "../../index"
import { GlobalState } from "../../../../store"

export interface Props {
    field: ICheckboxField
}

export const CheckboxField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const { currentFieldInEditMode = "" } = useAppSelector(
        (state: GlobalState) => state.fields,
    )

    const {
        position: _position,
        odataType: _odataType,
        value,
        ...fieldProps
    } = field

    const { ClickHereToEdit } = Labels

    const isDisabled =
        fieldProps.isDisabled ||
        !["", fieldProps.fieldId].includes(currentFieldInEditMode)

    return (
        <Checkbox
            {...fieldProps}
            description={
                <HTMLAndInternalLinkParser
                    content={(field?.description as string) ?? ""}
                />
            }
            value={value}
            isDisabled={isDisabled}
            placeholder={ClickHereToEdit}
            onSave={async (newValue: boolean): Promise<void> => {
                if (newValue === value) {
                    return
                }
                await dispatch(
                    updateField({
                        field,
                        newValue,
                    }),
                ).unwrap()
            }}
        />
    )
}

export default CheckboxField
